<!--
@author:panshuwei
@date:2018-10-18
@description:模态弹窗的表格
-->
<template>
  <transition>
    <div>
      <a-table
        :size="'default'"
        :columns="columns"
        :dataSource="rows"
        :rowKey="uuid"
        :loading="loading"
        :pagination="false"
        :rowSelection="rowSelection"
        :min-height="'1200px'"
        :expandedRowKeys="expandedRowKeys"
        :scroll="{ x: true, y: 0 }"
        @expand="(expanded,record) => expandHandler(expanded,record)"
        bordered
      >
        <template
          slot="index"
          slot-scope="text, record, index"
        >{{(currentPage - 1)*(currentPageSize) + index + 1}}</template>
        <template slot="linkField" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'onDetailClick')">{{text}}</a>
            </span>
          </div>
        </template>
        <template slot="linkField1" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'linkField1')">{{text}}</a>
            </span>
          </div>
        </template>
        <template slot="linkField2" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'linkField2')">{{text}}</a>
            </span>
          </div>
        </template>
        <template slot="linkField3" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'linkField3')">{{text}}</a>
            </span>
          </div>
        </template>
        <template slot="linkField4" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'linkField4')">{{text}}</a>
            </span>
          </div>
        </template>
        <template slot="linkField5" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'linkField5')">{{text}}</a>
            </span>
          </div>
        </template>
        <template slot="linkField6" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'linkField6')">{{text}}</a>
            </span>
          </div>
        </template>
        <template slot="linkField7" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'linkField7')">{{text}}</a>
            </span>
          </div>
        </template>
        <template slot="linkField8" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'linkField8')">{{text}}</a>
            </span>
          </div>
        </template>
        <template slot="linkField9" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'linkField9')">{{text}}</a>
            </span>
          </div>
        </template>
        <template slot="product_monitor_amount" slot-scope="text, record, index">
          <div class="editable-row-operations">{{text}}</div>
        </template>
        <template slot="improve_monitor_amount" slot-scope="text, record, index">
          <div class="editable-row-operations">{{text}}</div>
        </template>
        <template slot="improve_amount" slot-scope="text, record, index">
          <div class="editable-row-operations">{{text}}</div>
        </template>
        <template slot="product_amount" slot-scope="text, record, index">
          <div class="editable-row-operations">{{text}}</div>
        </template>
        <template slot="control_type" slot-scope="text, record, index">
          <div class="editable-row-operations">{{text}}</div>
        </template>
        <template slot="control_level" slot-scope="text, record, index">
          <div class="editable-row-operations">{{text}}</div>
        </template>
        <template slot="exception_amount" slot-scope="text, record, index">
          <div class="editable-row-operations">{{text}}</div>
        </template>
        <template slot="control_monitor_amount " slot-scope="text, record, index">
          <div class="editable-row-operations">{{text}}</div>
        </template>
        <template slot="company_amount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'company_amount')">{{record['company_amount']}}</a>
            </span>
          </div>
        </template>
        <template slot="abnormal_amount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'abnormal_amount')">{{record['abnormal_amount']}}</a>
            </span>
          </div>
        </template>
        <template slot="control_company_amount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a
                @click="() => fieldClick(record,'control_company_amount')"
              >{{record['control_company_amount']}}</a>
            </span>
          </div>
        </template>
        <template slot="exceed_company_amount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a
                @click="() => fieldClick(record,'exceed_company_amount')"
              >{{record['exceed_company_amount']}}</a>
            </span>
          </div>
        </template>
        <template slot="exceed_monitor_amount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a
                @click="() => fieldClick(record,'exceed_monitor_amount')"
              >{{record['exceed_monitor_amount']}}</a>
            </span>
          </div>
        </template>
        <template slot="product_amount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'product_amount')">{{record['product_amount']}}</a>
            </span>
          </div>
        </template>
        <template slot="improve_amount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'improve_amount')">{{record['improve_amount']}}</a>
            </span>
          </div>
        </template>
        <template slot="normalField" slot-scope="text, record, index">
          <div class="editable-row-operations">{{text}}</div>
        </template>
        <template slot="warningCount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'warningCount')">{{record['warningCount']}}</a>
            </span>
          </div>
        </template>
        <template slot="deviceCount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'deviceCount')">{{record['deviceCount']}}</a>
            </span>
          </div>
        </template>
        <template slot="companyName" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'companyName')">{{text}}</a>
            </span>
          </div>
        </template>
        <template slot="companyCount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'companyCount')">{{record['companyCount']}}</a>
            </span>
          </div>
        </template>
        <template slot="limitCount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'limitCount')">{{record['limitCount']}}</a>
            </span>
          </div>
        </template>
        <template slot="abnormalCount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'abnormalCount')">{{record['abnormalCount']}}</a>
            </span>
          </div>
        </template>
        <template slot="limitAreaCount" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'limitAreaCount')">{{record['limitAreaCount']}}</a>
            </span>
          </div>
        </template>
        <template slot="work_name" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'work_name')">{{record['work_name']}}</a>
            </span>
          </div>
        </template>
        <template slot="alarm_number" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'alarm_number')">{{record['alarm_number']}}</a>
            </span>
          </div>
        </template>
        <template slot="update_date" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a
                @click="() => fieldClick(record,'update_date')"
              >{{record['update_date'].substring(0, 4) + '-' + record['update_date'].substring(4, 6) + '-' + record['update_date'].substring(6, 8) + ' ' + record['update_date'].substring(8, 10) +':' + record['update_date'].substring(10, 12) + ':' + record['update_date'].substring(12, 14)}}</a>
            </span>
          </div>
        </template>
        <template slot="companyOperation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'contactClick')">联系人管理</a>
              <span class="separator">|</span>
              <a @click="() => outDetailClick(record)">设备管理</a>
              <span class="separator">|</span>
              <a @click="() => cardmanageClick(record)">用卡管理</a>
              <span class="separator">|</span>
              <a @click="() => fieldClick(record,'onMonitorClick')">配置管理</a>
              <span class="separator">|</span>
              <a @click="() => operaDetail(record)">详情</a>
              <span class="separator">|</span>
              <a @click="() => operaEdit(record)">编辑</a>
              <span class="separator">|</span>
              <a-popconfirm title="确认删除?" @confirm="() => operaDel(record)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </div>
        </template>
        <template slot="ProdOperation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => outDetailClick(record)">生产关系</a>
            </span>
          </div>
        </template>
        <template slot="companyListOperation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => outDetailClick(record)">监控分析</a>
            </span>
          </div>
        </template>
        <template slot="companyListOperationG" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => outDetailClickG(record)">监控分析</a>
            </span>
          </div>
        </template>
        <template slot="outOperation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'onDetailClick')">详情</a>
              <span class="separator">|</span>
              <a @click="() => fieldClick(record,'onEditClick')">编辑</a>
              <span class="separator">|</span>
              <a-popconfirm title="确认删除?" @confirm="() => fieldClick(record,'onDelClick')">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </div>
        </template>
        <template slot="ReviewOperation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'onDetailClick')">详情</a>
              <span
                v-show="record.hasOwnProperty('audit_state') && record.audit_state == 0 ? true:false"
              >
                <span class="separator">|</span>
                <a @click="() => fieldClick(record,'onReviewClick')">审核</a>
              </span>
            </span>
          </div>
        </template>
        <template slot="business_license_preurl" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span class="list">
              <dynamic-image :value="text ? text.split(',') : []" />
            </span>
          </div>
        </template>
        <!-- 新增营业执照字段 -->
        <template slot="businessLicenseUrl" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span class="list">
              <dynamic-image :value="text ? text.split(',') : []" />
            </span>
          </div>
        </template>
        <!-- 新增营业执照字段 -->
        <template slot="picture_url" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span class="list">
              <dynamic-image :value="text ? text.split(',') : []" />
            </span>
          </div>
        </template>
        <template slot="operation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => operaDetail(record)">详情</a>
              <span class="separator">|</span>
              <a @click="() => operaEdit(record)">编辑</a>
              <span class="separator">|</span>
              <a-popconfirm title="确认删除?" @confirm="() => operaDel(record)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </div>
        </template>
        <template slot="outEDOperation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'onDetailClick')">详情</a>
              <span class="separator">|</span>
              <!-- <a @click="() => fieldClick(record,'onEditClick')">编辑</a>
              <span class="separator">|</span>-->
              <a-popconfirm title="确认删除?" @confirm="() => operaDel(record)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </div>
        </template>
        <template slot="EDoutDoperation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => outDetailClick(record)">详情</a>
              <span class="separator">|</span>
              <a @click="() => operaEdit(record)">编辑</a>
              <span class="separator">|</span>
              <a-popconfirm title="确认删除?" @confirm="() => operaDel(record)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </div>
        </template>
        <template slot="detailOperation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => operaDetail(record)">详情</a>
            </span>
          </div>
        </template>
        <template slot="outDetailOperation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => outDetailClick(record)">详情</a>
            </span>
          </div>
        </template>
        <template slot="HeatMeterTemp" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span
              v-show="record.hasOwnProperty('TID') && record.TID  + '' != 'null' && record.TID + '' != ''? true:false"
            >
              <a @click="() => outTempDetailClick(record)">详情</a>
            </span>
          </div>
        </template>
        <template slot="HeatMeterFlow" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span
              v-show="record.hasOwnProperty('FID') && record.FID + '' != 'null' && record.FID + '' != ''? true:false"
            >
              <a @click="() => outFlowDetailClick(record)">详情</a>
            </span>
          </div>
        </template>
        <template slot="EDOperation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => operaEdit(record)">编辑</a>
              <span class="separator">|</span>
              <a-popconfirm title="确认删除?" @confirm="() => operaDel(record)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </div>
        </template>
        <template slot="SurveyOperation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'surveyClick')">点位勘察</a>
              <span class="separator">|</span>
              <a @click="() => fieldClick(record,'contactClick')">联系人</a>
              <span class="separator">|</span>
              <a-popconfirm title="确认删除?" @confirm="() => operaDel(record)">
                <a>删除</a>
              </a-popconfirm>
            </span>
          </div>
        </template>
        <template slot="declareOperation" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span>
              <a @click="() => fieldClick(record,'onDetailClick')">异常申报</a>
            </span>
          </div>
        </template>
        <template slot="status" slot-scope="text, record, index">
          <div class="editable-row-operations">
            <span v-if="record.status1 == 1" class="monitor_icon01_on"></span>
            <span v-if="record.status1 == 0" class="monitor_icon01_off"></span>
            <span v-if="record.status2 == 1" class="monitor_icon02_on"></span>
            <span v-if="record.status2 == 0" class="monitor_icon02_off"></span>
          </div>
        </template>
      </a-table>
      <div class="button-bar clearfix" v-show="showToolbar" style="margin-top:24px;">
        <a-row type="flex">
          <a-col :span="6">
            <div class="button-bar clearfix" v-show="showBatchButton">
              <a-button @click="() => selectAll()" style="float:left" type="default">全选</a-button>
              <a-button
                @click="() => delSelected()"
                style="float:left;margin-left:10px;"
                type="primary"
              >删除</a-button>
            </div>
          </a-col>
          <a-col :span="18">
            <div style="float:right" v-show="showPagination">
              <a-pagination
                :pageSize.sync="currentPageSize"
                showSizeChanger
                :pageSizeOptions="pageSizeOptions"
                @showSizeChange="onShowSizeChange"
                :total="total"
                :current.sync="currentPage"
                @change="onPaginationChange"
              />
            </div>
          </a-col>
        </a-row>
      </div>
      <a-modal
        :title="modelTitle"
        @ok="submit"
        centered
        @cancel="cancel"
        :bodyStyle="bodyStyle"
        okText="确认"
        :width="modelWidth"
        cancelText="取消"
        class="model-table-popup-box"
        :visible="modelVisible"
        :maskClosable="false"
        :confirmLoading="confirmLoading"
      >
        <a-form :autoFormCreate="(form) => autoFormCreate(form)">
          <a-row :gutter="20" :style="rowStyle">
            <a-col
              v-for="(editItem,index) in currentRecord"
              :key="index"
              v-show="!editItem.hide"
              :span="editItem.span ? editItem.span:12"
            >
              <div
                :class="editItem.hasOwnProperty('class')?'flex-box ' +  editItem.class : 'flex-box word14'"
              >
                <p class="a-label" v-if="editItem.type !== 'more'">
                  <span v-show="editItem.required" class="red-star">*</span>
                  {{editItem.label}}：
                </p>
                <div :class="editItem.type == 'more' ? 'modelSeparator': 'a-box'">
                  <a-form-item
                    :label="''"
                    :fieldDecoratorId="editItem.field"
                    :labelCol="{ span: 0 }"
                    :wrapperCol="{ span: 24}"
                    :fieldDecoratorOptions="editItem.rules?editItem.rules:{}"
                  >
                    <a-input-search
                      v-if="(editItem.type == 'number' || editItem.type == 'string') && editItem.hasOwnProperty('refresh')"
                      :disabled="editItem.hasOwnProperty('disabled') ? editItem.disabled:false"
                      :style="editItem.hasOwnProperty('style') ? editItem.style:''"
                      v-model="editItem.value"
                      :value="editItem.value"
                      @search="onAutoObtain(editItem)"
                    >
                      <a-button
                        :disabled="editItem.hasOwnProperty('disabled') ? editItem.disabled:false"
                        slot="enterButton"
                      >{{editItem.refresh}}</a-button>
                    </a-input-search>

                    <a-input
                      v-else-if="(editItem.type == 'number' || editItem.type == 'string') && editItem.hasOwnProperty('unit')"
                      :disabled="editItem.hasOwnProperty('disabled') ? editItem.disabled:false"
                      :style="editItem.hasOwnProperty('style') ? editItem.style:''"
                      v-model="editItem.value"
                      :value="editItem.value"
                      :addonAfter="editItem.unit"
                    />

                    <a-input
                      v-else-if="editItem.type == 'number' || editItem.type == 'string'"
                      :disabled="editItem.hasOwnProperty('disabled') ? editItem.disabled:false"
                      :style="editItem.hasOwnProperty('style') ? editItem.style:''"
                      v-model="editItem.value"
                      :value="editItem.value"
                    />

                    <a-select
                      class="full-input"
                      v-else-if="editItem.type == 'static_select'"
                      :getPopupContainer="triggerNode => triggerNode.parentNode"
                      :disabled="editItem.hasOwnProperty('disabled') ? editItem.disabled:false"
                      @change="value => handleSelectChange(value,editItem,currentRecord)"
                    >
                      <a-select-option
                        v-for="item in editItem.list"
                        :key="item.key"
                        :value="item.value"
                      >{{item.label}}</a-select-option>
                    </a-select>

                    <dynamic-refresh-select
                      v-else-if="editItem.type == 'dynamic_select' && editItem.hasOwnProperty('refreshUrl')"
                      :url="editItem.url"
                      ref="dynamicSelect"
                      :value="editItem.value"
                      :method="editItem.hasOwnProperty('method') ? editItem.method:'get'"
                      :options="editItem.hasOwnProperty('options') ? editItem.options:{}"
                      :disabled="editItem.hasOwnProperty('disabled') ? editItem.disabled:false"
                      :staticRecord="cfg.dynamicStatic"
                      @change="(value) => dynamicChange(value,editItem)"
                    />

                    <dynamic-select
                      v-else-if="editItem.type == 'dynamic_select'&&!editItem.forceRefresh"
                      :url="editItem.url"
                      ref="dynamicSelect"
                      :value="editItem.value"
                      :mode="editItem.hasOwnProperty('mode') ? editItem.mode : 'default'"
                      :method="editItem.hasOwnProperty('method') ? editItem.method:'get'"
                      :options="editItem.hasOwnProperty('options') ? editItem.options:{}"
                      :disabled="editItem.hasOwnProperty('disabled') ? editItem.disabled:false"
                      @onSelected="(value)=>dynamicOnSelect(value,editItem)"
                      @change="(value) => dynamicChange(value,editItem)"
                    />

                    <dynamic-select-search
                      v-else-if="editItem.type == 'dynamic_select_search'"
                      :url="editItem.url"
                      ref="dynamicSelect"
                      :value="editItem.value"
                      :mode="editItem.hasOwnProperty('mode') ? editItem.mode : 'default'"
                      :method="editItem.hasOwnProperty('method') ? editItem.method:'get'"
                      :options="editItem.hasOwnProperty('options') ? editItem.options:{}"
                      :disabled="editItem.hasOwnProperty('disabled') ? editItem.disabled:false"
                      @onSelected="(value)=>dynamicOnSelect(value,editItem)"
                      @change="(value) => dynamicChange(value,editItem)"
                    />

                    <dynamic-cascader
                      v-else-if="editItem.type == 'dynamic_cascader'&&!editItem.forceRefresh"
                      ref="dynamicCascader"
                      :url="editItem.url"
                      :changeOnSelect="editItem.changeOnSelect"
                      :method="'get'"
                      :value="editItem.value"
                      :disabled="editItem.hasOwnProperty('disabled') ? editItem.disabled:false"
                      @change="(value) => cascaderChanger(value,editItem,currentRecord)"
                    />

                    <DynamicTreeSelect
                      v-else-if="editItem.type == 'dynamic_treeSelect'"
                      :url="editItem.url"
                      :method="'get'"
                      :options="{}"
                      ref="dynamicTreeSelect"
                      :value="editItem.value + ''"
                      :disabled="editItem.hasOwnProperty('disabled') ? editItem.disabled:false"
                      @change="(value) => treeSelectChanger(value,editItem,currentRecord)"
                    />

                    <a-date-picker
                      v-else-if="editItem.type == 'date'"
                      class="full-input"
                      :format="editItem.hasOwnProperty('format') ? editItem.format:'YYYY-MM-DD'"
                      :disabled="editItem.hasOwnProperty('disabled') ? editItem.disabled:false"
                      :showTime="editItem.hasOwnProperty('mode') &&  editItem.mode == 'full-time' ? defaultShowTime : false"
                      @change="(date,dateString) => dateOnChange(date, dateString, editItem)"
                    />

                    <dynamic-upload
                      :max="4"
                      style="padding-bottom:45px;"
                      v-else-if="editItem.type == 'file'"
                      :value="uploadList"
                      :options="{label:editItem.label}"
                      @change="(value) => uploadChange(value,editItem,currentRecord)"
                    />

                    <MoreSeparator
                      v-else-if="editItem.type == 'more'"
                      :mode="collapseMode"
                      @moreClick="() => moreClick()"
                    />
                    <span
                      v-if="editItem.hasOwnProperty('cantEdit') && editItem.cantEdit && currentMode == 'edit'"
                      style="position: absolute;left: 0;top: 16px;font-size: 10px;color: #FF5147;"
                    >不可修改，若需修改请先删除</span>
                  </a-form-item>
                </div>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <a-modal
        :title="detailTitle"
        @ok="detailSubmit"
        centered
        @cancel="detailSubmit"
        okText="确认"
        :width="modelWidth"
        cancelText="取消"
        :footer="null"
        :visible="detailVisible"
        :confirmLoading="confirmLoading"
      >
        <a-row :gutter="20">
          <a-col
            v-for="(editItem,index) in currentRecord"
            :key="index"
            v-show="!editItem.hide && !editItem.canShowInDetail && editItem.type != 'dynamic_cascader'"
            :span="editItem.span ? editItem.span:12"
            class="model-row"
          >
            <div v-if="editItem.type == 'file'" style="line-height:32px;">
              <div
                :class="editItem.hasOwnProperty('class') ? 'flex-box ' +  editItem.class : 'flex-box word8'"
              >
                <p
                  class="a-label"
                  :title="editItem.hasOwnProperty('detailLabel')?editItem.detailLabel:editItem.label"
                  style="line-height:32px;"
                >
                  <span
                    class="detail-label"
                  >{{editItem.hasOwnProperty('detailLabel')?editItem.detailLabel:editItem.label}}：</span>
                </p>
                <div class="a-box">
                  <div style="line-height:32px;">
                    <dynamic-image :value="editItem[editItem.detailField]" />
                  </div>
                </div>
              </div>
            </div>

            <div v-else-if="editItem.type == 'static_select'">
              <p
                class="a-label"
                :title="editItem.hasOwnProperty('detailLabel')?editItem.detailLabel:editItem.label"
                style="line-height:32px;"
              >
                <span
                  class="detail-label"
                >{{editItem.hasOwnProperty('detailLabel')?editItem.detailLabel:editItem.label}}：</span>
                {{
                getDetailValue(editItem)
                }}
              </p>
            </div>

            <div
              v-else-if="editItem.type == 'dynamic_select' || editItem.type == 'dynamic_treeSelect' || editItem.type == 'dynamic_cascader'"
            >
              <p
                class="a-label"
                :title="editItem.hasOwnProperty('detailLabel')?editItem.detailLabel:editItem.label"
                style="line-height:32px;"
              >
                <span
                  class="detail-label"
                >{{editItem.hasOwnProperty('detailLabel')?editItem.detailLabel:editItem.label}}：</span>
                {{
                getDyamicSelectDetailValue(editItem)
                }}
              </p>
            </div>

            <div v-else>
              <p
                class="a-label"
                :title="editItem.hasOwnProperty('detailLabel')?editItem.detailLabel:editItem.label"
                style="line-height:32px;"
              >
                <span
                  class="detail-label"
                >{{editItem.hasOwnProperty('detailLabel')?editItem.detailLabel:editItem.label}}：</span>
                {{editItem.value}}
                {{editItem.hasOwnProperty('unit')?editItem.unit:''}}
              </p>
            </div>
          </a-col>
        </a-row>
      </a-modal>
    </div>
  </transition>
</template>

<script>
import _ from "underscore";
import eBase from "@/base/eBase.js";
import config from "@/base/config.js";
import moment, { now } from "moment";
import DynamicCascader from "@/components/select/DynamicCascader.vue";
import DynamicSelect from "@/components/select/DynamicSelect.vue";
import DynamicSelectSearch from "@/components/select/DynamicSelectSearch.vue";
import DynamicRefreshSelect from "@/components/select/DynamicRefreshSelect.vue";
import DynamicTreeSelect from "@/components/select/DynamicTreeSelect.vue";
import DynamicUpload from "@/components/select/DynamicUpload.vue";
import DynamicImage from "@/components/select/DynamicImage.vue";
import MoreSeparator from "@/components/select/MoreSeparator.vue";
import { setTimeout } from "timers";

export default {
  name: "ModelTable",
  components: {
    DynamicCascader,
    DynamicSelect,
    DynamicUpload,
    DynamicImage,
    DynamicTreeSelect,
    DynamicRefreshSelect,
    MoreSeparator,
    DynamicSelectSearch
  },

  props: {
    url: {
      required: true
    },
    addUrl: {
      required: true
    },
    editUrl: {
      required: true
    },
    delUrl: {
      required: true
    },
    columns: {
      required: true
    },
    editOptions: {
      required: false
    },
    options: {
      required: false,
      default() {
        return {
          params: {}
        };
      }
    },
    method: {
      required: false,
      default: "get"
    },
    cfg: {
      required: true
    },
    pageSize: {
      required: false,
      default: 12
    },
    fieldFormater: {
      required: false,
      default() {
        return {};
      }
    },
    showToolbar: {
      required: false,
      default: true
    },
    showBatchButton: {
      required: false,
      default: true
    },
    showPagination: {
      required: false,
      default: true
    },
    staticRecord: {
      required: false,
      default() {
        return {};
      }
    },
    isChildren:{
      required: false,
      default: false
    },
    modelWidth: {
      required: false,
      defualt: "774px"
    },
    uuid: {
      required: false,
      default: "id"
    } // key of table
  },

  watch: {
    options: {
      handler(newValue, oldValue) {
        eBase.debug("[ModelTable.vue][options][change]");
        this.refreshFirstPage();
      },
      deep: true,
      immediated: true
    },
    editOptions: {
      handler(newValue, oldValue) {
        eBase.debug("[ModelTable.vue][editOptions][change]");
        this.toCurrentRecord(newValue);
      },
      immediated: false
    },
    pageSize: {
      handler(newValue, oldValue) {
        eBase.debug("[ModelTable.vue][pageSize][change]");
        this.currentPageSize = newValue;
      },
      immediated: false
    },
    showBatchButton: {
      handler(newValue, oldValue) {
        if (!newValue) {
          this.rowSelection = null;
        }
      },
      immediated: true
    },
    currentMode: {
      handler(newValue, oldValue) {
        if (newValue == "add") {
          this.modelTitle = "添加";
        } else if (newValue == "edit") {
          this.modelTitle = "编辑";
        } else {
          this.modelTitle = "";
        }
      },
      immediated: true
    }
  },

  data() {
    return {
      moment,
      rows: [],
      detailVisible: false,
      modelVisible: false,
      confirmLoading: false,
      loading: false,
      modelTitle: "添加",
      detailTitle: "详情",
      currentRecord: [],
      currentMode: "add",
      currentPageSize: 10,
      currentPage: 1,
      total: 0,
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.rowSelection.selectedRowKeys = selectedRowKeys;
        },
        selectedRowKeys: []
      },
      form: null,
      pageSizeOptions: ["10", "20", "50"],
      bodyStyle: {
        maxHeight: "700px",
        overflow: "auto"
      },
      selectValues: {},
      cascaderValues: {},
      uploadList: [],
      expandedRowKeys: [],
      formRecord: {},
      currentDetailRecord: {},
      defaultShowTime: {
        defaultValue: moment("00:00:00", "HH:mm:ss")
      },
      rowStyle: {},
      collapseMode: true
    };
  },

  created() {
    eBase.debug("[ModelTable.vue][created][enter]");
    this.onCreated();
  },

  beforeMount() {
    eBase.debug("[ModelTable.vue][beforeMount][enter]");
  },

  mounted() {
    eBase.debug("[ModelTable.vue][mounted][enter]");
  },

  methods: {
    onCreated() {
      if (!this.showBatchButton) {
        this.rowSelection = null;
      }
      this.initRowStyle();
    },

    init() {
      this.refreshFirstPage();
    },

    initRowStyle() {
      if (
        this.cfg &&
        this.cfg.hasOwnProperty("pageId") &&
        this.cfg.pageId == "EnterpriseManager"
      ) {
        this.collapseMode = true;
        this.rowStyle = {
          maxHeight: "400px",
          overflow: "hidden"
        };
      }
    },

    query() {
      this.refreshFirstPage();
    },

    toCurrentRecord(list) {
      const self = this;
      self.currentRecord = [];
      _.each(list, item => {
        const one = _.clone(item);
        self.currentRecord.push(one);
      });
    },

    openAddModel() {
      const self = this;
      this.currentMode = "add";
      this.selectValues = {};
      this.cascaderValues = {};
      this.uploadValues = {};
      this.toCurrentRecord(this.editOptions);
      this.initRowStyle();
      this.openModel();

      const emptyRecord = {};

      _.each(this.editOptions, item => {
        emptyRecord[item.field] = _.has(self.fieldFormater, item.field)
          ? self.fieldFormater[item.field].setter(item.value)
          : item.value;
      });

      this.formRecord = emptyRecord;
      this.uploadList = [];
      this.$nextTick(() => {
        self.form && self.form.setFieldsValue(emptyRecord);
      });
    },

    searchOnePage(pageSize, pageIndex) {
      this.loading = true;
      this.expandedRowKeys = [];

      const self = this;
      let newOpt = {};

      if (this.cfg && _.has(this.cfg, "pagination") && !this.cfg.pagination) {
        newOpt = _.extend(this.options, {});
      } else {
        newOpt = _.extend(this.options, {
          pageSize,
          pageIndex
        });
      }

      //这么写是怕影响其他的接口，后面定义组件这种应该考虑到get请求的方式
      // console.log(this.method);
      if (this.url == "/sys/orgElectricStatistics/selectdateOrg") {
        eBase
          .send(
            {
              url:
                this.url +
                "?start_time=" +
                newOpt.start_time +
                "&end_time=" +
                newOpt.end_time
            },
            "get"
          )
          .then(
            res => {
              this.loading = false;
              self.rows = res.data.rows || res.data.data;
              self.total = parseInt(res.data.total);
              self.selectNull();
            },
            err => {
              this.loading = false;
            }
          );
      } else {
        eBase
          .send(
            {
              url: this.url,
              params: newOpt
            },
            "post"
          )
          .then(
            res => {
              this.loading = false;
              self.rows = res.data.rows || res.data.data;
              self.total = parseInt(res.data.total);
              self.selectNull();
            },
            err => {
              this.loading = false;
            }
          );
      }
    },

    add(obj) {
      eBase
        .send(
          {
            url: this.addUrl,
            params: obj
          },
          "post"
        )
        .then(
          res => {
            this.closeModel();
            this.refreshFirstPage();
            this.refreshDynamicComponents();
            this.$emit("dataChange");
          },
          err => {
            this.$message.error(err.data.msg);
          }
        );
    },

    edit(obj) {
      eBase
        .send(
          {
            url: this.editUrl,
            params: obj
          },
          "post"
        )
        .then(
          res => {
            this.closeModel();
            this.refreshCurrentPage();
            this.refreshDynamicComponents();
            this.$emit("dataChange");
          },
          err => {
            this.$message.error(err.data.msg);
          }
        );
    },

    del(value) {
      const arr = [value];
      eBase
        .send(
          {
            url: this.delUrl,
            params: arr
          },
          "post"
        )
        .then(
          res => {
            this.$message.success("删除成功");
            this.refreshCurrentPage();
            this.refreshDynamicComponents();
            this.$emit("dataChange");
          },
          err => {
            this.$message.error(err.data.msg);
          }
        );
    },

    delByArr(arr) {
      eBase
        .send(
          {
            url: this.delUrl,
            params: arr
          },
          "post"
        )
        .then(
          res => {
            this.$message.success("删除成功");
            this.refreshCurrentPage();
            this.$emit("dataChange");
          },
          err => {
            this.$message.error(err.data.msg);
          }
        );
    },

    openModel() {
      this.modelVisible = true;
    },

    openDetail() {
      this.detailVisible = true;
    },

    closeModel() {
      this.modelVisible = false;
    },

    detailSubmit() {
      this.detailVisible = false;
    },

    submit() {
      const self = this;
      this.form &&
        this.form.validateFieldsAndScroll((err, values) => {
          if (!err) {
            const record = {
              ...values,
              ...self.selectValues,
              ...self.cascaderValues
              // ...self.uploadValues
            };
            if(record.business_license !== undefined) {
              record.business_license = this.formatUpload(this.uploadList);
            }

            if(record.picture_path !== undefined) {
              record.picture_path = this.formatUpload(this.uploadList);
            }

            const newRecord = self.handleBeforeSave(_.clone(record));

            if (this.checkMn(record)) return;
            switch (self.currentMode) {
              case "add":
                if (newRecord) {
                  delete newRecord[this.uuid];
                }
                if(!!self.isChildren){
                    self.staticRecord.children=[];
                    self.staticRecord.workshop_name=newRecord.workshop_name;
                    self.staticRecord.device_name=newRecord.device_name;
                    newRecord.type="7";
                    delete newRecord["workshop_name"];
                    delete newRecord["device_name"];
                    self.staticRecord.children.push(newRecord)
                    this.add(self.staticRecord);
                }else{
                  this.add({ ...newRecord, ...self.staticRecord });
                }

                break;
              case "edit":
                if(newRecord && newRecord.hasOwnProperty("num")) {
                  delete newRecord["num"];
                }
                if(!!self.isChildren){

                    newRecord.type="7";
                    delete newRecord["children"];
                    this.edit({ ...newRecord, ...self.staticRecord });
                }else{
                    this.edit({ ...newRecord, ...self.staticRecord });
                }
                break;
              case "detail":
                break;
              default:
                break;
            }
          }
        });
    },

    cancel() {
      this.closeModel();
    },

    operaDel(record) {
      eBase.debug("[ModelTable.vue][operaDel][enter]");
      this.del(record[this.uuid]);
    },

    operaEdit(record) {
      eBase.debug("[ModelTable.vue][operaEdit][enter]");

      const self = this;

      this.currentMode = "edit";
      this.toCurrentRecord(this.editOptions);
      this.initRowStyle();

      _.each(_.keys(record), key => {
        self.filterArr(key, record[key]);
      });

      this.setFormRecord(record);
      const newRecord = this.handleBeforeEdit(_.clone(record));
      const setRecord = {
        ..._.pick(newRecord, this.getEditFields(this.editOptions))
      };
      this.uploadList = [];
      if (newRecord.business_license) {
        let pathArr = newRecord.businessLicenseUrl.split(",");
        let filePathArr = newRecord.business_license.split(",");
        let fullPath = [];
        pathArr.forEach((item, i) => {
          let onePath = {
            url: item,
            uid: -i + "",
            status: "done",
            name: "xxx.png"
          };
          fullPath.push(onePath);
        });

        filePathArr.forEach((item1, j) => {
          fullPath[j]["filePath"] = item1;
        });
        this.uploadList = fullPath;
        setRecord.business_license = this.uploadList;
      }else if (newRecord.picture_path) {
        let pathArr = newRecord.picture_url.split(",");
        let filePathArr = newRecord.picture_path.split(",");
        let fullPath = [];
        pathArr.forEach((item, i) => {
          let onePath = {
            url: item,
            uid: -i + "",
            status: "done",
            name: "xxx.png"
          };
          fullPath.push(onePath);
        });

        filePathArr.forEach((item1, j) => {
          fullPath[j]["filePath"] = item1;
        });
        this.uploadList = fullPath;
        setRecord.picture_path = this.uploadList;
      }
      this.openModel();
      this.$nextTick(() => {
        self.form && self.form.setFieldsValue(setRecord);
      });
    },

    operaDetail(record) {
      eBase.debug("[ModelTable.vue][operaDetail][enter]");
      const self = this;
      this.currentMode = "detail";
      self.toCurrentRecord(this.editOptions);

      _.each(_.keys(record), key => {
        self.filterArr(key, record[key]);
      });

      _.each(_.keys(record), key => {
        const target = self.currentRecord.filter(one => one.field == key)[0];

        if (
          target &&
          _.has(target, "detailField") &&
          record[target.detailField]
        ) {
          if("monitorTypeNames" == target.detailField){
            target[target.detailField] = record[target.detailField];
          }else{
            target[target.detailField] = record[target.detailField].split(",");
          }
        }

        if (_.has(target, "actualShow")) {
          const actualShow = _.pick(record, target.actualShow);
          _.each(self.currentRecord, (item, index) => {
            if (item.field == key) {
              item.value = actualShow[target.actualShow];
            }
          });
        }

        if (_.has(target, "actualLabel")) {
          _.each(self.currentRecord, (item, index) => {
            if (item.field == key) {
              item.label = target.actualLabel;
            }
          });
        }
      });

      this.currentDetailRecord = record;

      this.openDetail();
    },

    dateOnChange(date, dateString, record) {
      this.filterArr(record.field, dateString);
    },

    filterArr(key, value) {
      const target = this.currentRecord.filter(one => one.field == key)[0];
      if (target) {
        target.value = value;
        // if (key === "register_date") {
        //   if (!value) {
        //     target.value = now;
        //   } else {
        //     target.value = value;
        //   }
        // } else {
        //   target.value = value;
        // }
      }
    },

    selectAll() {
      const self = this;

      if (self.rowSelection.selectedRowKeys.length < self.rows.length) {
        self.rowSelection.selectedRowKeys = [];
        _.each(self.rows, item => {
          self.rowSelection.selectedRowKeys.push(item[self.uuid]);
        });
      } else {
        self.selectNull();
      }
    },

    selectNull() {
      if (this.rowSelection && this.rowSelection.selectedRowKeys) {
        this.rowSelection.selectedRowKeys = [];
      }
    },

    delSelected() {
      const self = this;
      const arr =
        this.rowSelection && this.rowSelection.selectedRowKeys
          ? this.rowSelection.selectedRowKeys
          : [];

      if (!arr || arr.length == 0) {
        this.$message.success("请选择条目");
        return;
      }

      this.$confirm({
        title: "确定刪除?",
        content: '确定删除选中的数据?，删除请点击"确定",不删除请点击"取消"',
        maskClosable: true,
        centered: true,
        class: "top300",
        onOk() {
          const ids = [];
          ids.push(...arr);
          self.delByArr(ids);
        }
      });
    },

    refreshFirstPage() {
      this.currentPage = 1;
      this.searchOnePage(this.currentPageSize, this.currentPage);
    },

    refreshCurrentPage() {
      this.searchOnePage(this.currentPageSize, this.currentPage);
    },

    onPaginationChange(current) {
      this.currentPage = current;
      this.searchOnePage(this.currentPageSize, this.currentPage);
    },

    onShowSizeChange(current, pageSize) {
      this.currentPageSize = pageSize;
      this.refreshFirstPage();
    },

    autoFormCreate(form) {
      this.form = form;
      this.registerDecorator();
    },

    getEditFields(arr) {
      let result = [];

      if (_.has(this.cfg, "editField")) {
        result = this.cfg.editFields;
      } else {
        result = [];
        _.each(arr, one => {
          result.push(one.field);
        });
      }

      return result;
    },

    handleSelectChange(value, editItem, currentRecord) {
      const self = this;

      this.selectValues[editItem.field] = value;

      if (editItem.hasOwnProperty("handleChange")) {
        const disableRecords = editItem.handleChange(
          value,
          editItem,
          currentRecord
        );
        self.$nextTick(() => {
          self.form && self.form.setFields(disableRecords);
        });
      }
    },

    cascaderChanger(value, editItem, currentRecord) {
      this.cascaderValues[editItem.field] = value;
    },
    // 上传数据改变
    uploadChange(value, editItem, currentRecord) {
      this.uploadList = value;
      // this.uploadValues[editItem.field] = value
      //   .map(item => {
      //     return item.response.data.filePath;
      //   })
      //   .join(",");
    },

    formatUpload(value) {
      const result = [];
      const list = _.isArray(value) ? value : value.fileList;

      _.each(list, one => {
        if (one.filePath) {
          result.push(one.filePath);
        } else if (one.response) {
          result.push(one.response.data.filePath);
        }
      });
      return result.join(",");
    },

    treeSelectChanger(value, editItem, currentRecord) {},

    handleBeforeEdit(record) {
      const self = this;
      // handle setter
      _.each(_.keys(record), key => {
        record[key] = _.has(self.fieldFormater, key)
          ? self.fieldFormater[key].setter(record[key], record)
          : record[key];
      });

      // handle dynamic cascader field
      _.each(self.pick("dynamic_cascader"), onefield => {
        const newS = [];
        const arr = onefield.split(",");
        if (arr && arr.length > 1) {
          // 只处理field多个的情况
          _.each(arr, one => {
            record[one] && newS.push(record[one] + "");
            delete record[one];
          });

          record[onefield] = newS;
        }
      });

      // handle not save field for page floormanage.vue
      const flag =
        _.has(this.cfg, "page") &&
        this.cfg.page == "FloorManager" &&
        _.has(this.cfg, "notSaveFields") &&
        _.isArray(this.cfg.notSaveFields);

      flag &&
        _.each(this.cfg.notSaveFields, onefield => {
          if (onefield == "type") {
            const typevalue = record.parentId == "-1" ? "0" : "1";
            record[onefield] = typevalue;
            self.typeChangeHandler(typevalue, {}, self.currentRecord);
          }
        });

      _.each(this.currentRecord, item => {
        if (item.hasOwnProperty("cantEdit") && item.cantEdit) {
          item.disabled = true;
        }
      });


      if (flag && (!record.hasOwnProperty("bUNum") || record.bUNum === "")) {
        record.bUNum = " ";
      }

      return record;
    },

    handleBeforeSave(record) {
      const self = this;

      // handle getter
      _.each(_.keys(record), key => {
        record[key] = _.has(self.fieldFormater, key)
          ? self.fieldFormater[key].getter(record[key], record)
          : record[key];
      });

      // handle undefined
      const delUndefined = _.has(this.cfg, "delUndefined")
        ? this.cfg.delUndefined
        : false;
      _.each(record, (value, key) => {
        if (_.isUndefined(value) || value == "undefined" || value == "null") {
          delUndefined && delete record[key];
          !delUndefined && (record[key] = "");
        }
      });

      // handle multi-field which is split by ',' eg: area
      _.each(_.keys(record), key => {
        const fields = key.split(",");
        if (fields.length >= 2) {
          _.each(fields, (oneKey, index) => {
            record[oneKey] =
              record[key] && record[key][index] ? record[key][index] : "";
          });

          delete record[key];
        }
      });

      // delete notSaveFields
      if (
        _.has(this.cfg, "notSaveFields") &&
        _.isArray(this.cfg.notSaveFields)
      ) {
        _.each(self.cfg.notSaveFields, field => {
          delete record[field];
        });
      }

      // handle special record特殊情况处理，调用外部的一个函数来处理
      if (
        _.has(this.cfg, "handleBeforeSave") &&
        _.isFunction(this.cfg.handleBeforeSave)
      ) {
        this.cfg.handleBeforeSave(record);
      }

      return record;
    },

    typeChangeHandler(value, editItem, currentRecord) {
      const result = {};

      _.each(currentRecord, item => {
        if (
          _.has(item, "showType") &&
          (item.showType == value || item.showType == "-1")
        ) {
          item.disabled = false;

          let defaultValue = "";

          if (item.field == "parentId") {
            defaultValue = [];
          }

          result[item.field] = {
            value: defaultValue
          };
        } else {
          item.disabled = true;
          item.value = "";

          let defaultValue = "";

          if (item.field == "parentId") {
            defaultValue = "-1";
          }

          result[item.field] = {
            value: defaultValue
          };
        }

        if (item.field == "type") {
          item.disabled = true;
        }
      });

      return result;
    },

    registerDecorator() {
      const self = this;
      _.each(this.pick("dynamic_cascader"), cf => {
        self.form &&
          self.form.getFieldDecorator(cf, {
            valuePropName: "value"
          });
      });

      _.each(this.pick("dynamic_select"), cf => {
        self.form &&
          self.form.getFieldDecorator(cf, {
            initialValue: [],
            valuePropName: "value",
            trigger: "change",
            validateTrigger: "change",
            getValueFromEvent: self.getCustomSelectValue,
            rules: [
              {
                validator: self.checkDynamicSelect
              }
            ]
          });
      });

      _.each(this.pick("file"), ff => {
        self.form &&
          self.form.getFieldDecorator(ff, {
            initialValue: [],
            valuePropName: "value",
            trigger: "change",
            validateTrigger: "change",
            getValueFromEvent: self.getUploadValue
          });
      });
    },

    refreshDynamicComponents() {
      this.$refs.dynamicSelect &&
        _.each(this.$refs.dynamicSelect, one => {
          one.search();
        });
    },

    getCustomSelectValue(value) {
      return value;
    },

    getUploadValue(value) {
      return value;
    },

    dynamicOnSelect(v, editItem) {},

    dynamicChange(value, editItem) {
      const self = this;
      this.formRecord[editItem.field] = value;
      this.handleFieldsCascader(value, editItem);
      if (
        this.cfg &&
        this.cfg.hasOwnProperty("pageId") &&
        this.cfg.pageId == "DeviceTreeManage" &&
        editItem.field == "type"
      ) {
        self.form &&
          self.form.setFieldsValue({
            factor: ""
          });
      }
    },

    handleFieldsCascader(value, editItem) {
      const presetValue = this.form.getFieldsValue([
        "name",
        "parent_id",
        "debug_state"
      ]);
      let jsonData;
      // todo
      // 将需要这字段值的options重新设置
      if (_.has(editItem, "relatedChild")) {
        const presetKeys = Object.keys(presetValue),
          options = this.editOptions,
          hideFiledsArr = [];
        // 找到editoption中需要隐藏的字段
        _.each(this.editOptions, (item, index) => {
          if (item.hide === true) {
            hideFiledsArr.push(item.field);
          }
        });
        // const timeReg = /^[1-9]\d{3}(0[1-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;
        for (const d in this.formRecord) {
          if (
            d !== editItem.field &&
            !~hideFiledsArr.indexOf(d) &&
            d !== "company_id"
          ) {
            const flag = Object.prototype.toString.call(this.formRecord[d]);
            if (flag === "[object Object]") {
              if (this.moment.isMoment(this.formRecord[d])) {
                this.formRecord[d] = this.moment();
              } else {
                this.formRecord[d] = {};
              }
            } else if (flag === "[object Array]") {
              this.formRecord[d] = [];
            } else if (
              editItem.format2Date &&
              ~editItem.format2Date.indexOf(d)
            ) {
              this.formRecord[d] = this.moment();
            } else {
              this.formRecord[d] = "";
            }
          }
        }
        _.each(presetKeys, (item, index) => {
          this.formRecord[item] = presetValue[item]; // 防止已经填写的值置空
        });
        this.$nextTick(() => {
          _.each(options, (item, index) => {
            if (item.field === editItem.relatedChild) {
              item.options[editItem.field] = value;
              item.forceRefresh !== undefined && (item.forceRefresh = true);
            }
          });
          this.$emit("update:editOptions", [...options]);
          setTimeout(() => {
            _.each(options, (item, index) => {
              if (item.field === editItem.relatedChild) {
                item.forceRefresh = false;
              }
            });
            this.$emit("update:editOptions", [...options]);
          }, 0);
          this.form.setFieldsValue(this.formRecord);
        });
        // 选择类型将操作框置为可操作
        _.each(options, (itemInner, indexInner) => {
          if (
            editItem.autoCompleteItems &&
            ~editItem.autoCompleteItems.indexOf(itemInner)
          ) {
            itemInner.disabled = false;
          }
        });
        this.formRecord.is_shadow = 0;
      }
      // 选择后将操作框置灰
      if (_.has(editItem, "relatedParent")) {
        jsonData = value ? JSON.parse(value) : value;
        const presetKeys = Object.keys(presetValue),
          options = this.editOptions;
        _.each(presetKeys, (item, index) => {
          this.formRecord[item] = presetValue[item]; // 防止已经填写的值置空
        });
        this.formRecord.type = "" + this.formRecord.type; // 转为string
        setTimeout(() => {
          _.each(editItem.autoCompleteItems, (item, index) => {
            _.each(options, (itemInner, indexInner) => {
              if (itemInner.field === item) {
                itemInner.disabled = true;
              }
              if (jsonData == -1) {
                itemInner.disabled = false;
              }
            });
          });
          _.each(options, (itemInner, indexInner) => {
            if (!jsonData) {
              itemInner.disabled = false;
            }
          });
          this.$emit("update:editOptions", [...this.editOptions]);
        }, 0);

        if (jsonData !== -1) {
          this.formRecord.is_shadow = 1;
          this.formRecord[editItem.actualShow] = jsonData[editItem.actualShow];
        } else {
          this.formRecord.is_shadow = 0;
        }
      }
      // add by skx   自动填充其他field的值
      if (editItem.autoCompleteItems && jsonData) {
        for (let fieldKey of editItem.autoCompleteItems) {
          if (editItem.format2Date && ~editItem.format2Date.indexOf(fieldKey)) {
            if (jsonData[fieldKey]) {
              this.formRecord[fieldKey] = this.moment(
                jsonData[fieldKey],
                "YYYYMMDDHHmmss"
              );
            } else {
              this.formRecord[fieldKey] = "";
            }
          } else {
            this.formRecord[fieldKey] = jsonData[fieldKey];
          }
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(this.formRecord);
        });
      }
    },

    checkDynamicSelect(rule, value, callback) {
      if (value != "") {
        callback();
        return;
      }
      callback("please check");
    },

    pick(type) {
      const self = this;
      const result = [];

      _.each(this.editOptions, item => {
        if (item.type == type) {
          result.push(item.field);
        }
      });

      return result;
    },

    outDetailClick(record) {
      this.$emit("onDetailClick", record);
    },

    outDetailClickG(record) {
      this.$emit("onDetailClick", record);
    },

    cardmanageClick(record) {
      this.$emit("cardmanageClick", record);
    },

    fieldClick(record, eventName) {
      this.$emit(eventName, record);
    },

    outTempDetailClick(record) {
      this.$emit("outTempDetailClick", record);
    },

    outFlowDetailClick(record) {
      this.$emit("outFlowDetailClick", record);
    },

    enlarge(text) {
      this.$emit("enlarge", text);
    },

    expandHandler(expanded, record) {
      if (_.has(this.cfg, "unexpanded") && this.cfg.unexpanded) {
        this.expandedRowKeys.push(record[this.uuid]);
        return;
      }

      if (!expanded) {
        this.expandedRowKeys.splice(
          this.expandedRowKeys.indexOf(record[this.uuid]),
          1
        );
        return;
      }

      this.expandedRowKeys.push(record[this.uuid]);

      if (_.has(this.cfg, "childUrl")) {
        this.loading = true;

        const newOpt = _.extend(
          {},
          {
            pageSize: 0,
            pageIndex: 0,
            params: {
              parentId: record[this.uuid]
            }
          }
        );

        eBase
          .send(
            {
              url: this.cfg.childUrl,
              params: newOpt
            },
            "post"
          )
          .then(
            res => {
              const target = this.fileterFromTree(
                this.rows,
                record[this.uuid]
              )[0];
              if (target) {
                target.children = res.data.rows;
              }
              this.loading = false;
            },
            err => {
              this.loading = false;
            }
          );
      }
    },

    fileterFromTree(arr, key) {
      var self = this;
      var result = [];

      result = _.filter(arr, item => key == item[self.uuid]);

      if (result.length > 0) {
        return _.filter(arr, item => key == item[self.uuid]);
      }

      try {
        _.each(arr, one_item => {
          if (one_item.hasOwnProperty("children")) {
            result = self.fileterFromTree(one_item.children, key);
            if (result.length > 0) {
              throw new Error("break");
            }
          }
        });
      } catch (e) {
        if (e.message == "break") {
          eBase.debug(
            "[TreeMenuTable.vue][fileterFromTree][break each success]"
          );
          return result;
        }
      }

      return result;
    },

    onAutoObtain(editItem) {
      const self = this;

      let newOption = {};

      if (
        this.cfg &&
        this.cfg.hasOwnProperty("pageId") &&
        this.cfg.pageId == "DeviceTreeManage"
      ) {
        if (
          _.isUndefined(this.formRecord.type) ||
          this.formRecord.type === ""
        ) {
          this.$message.info("请选择监测点类型！");
          return;
        }
        newOption = _.extend(editItem.options, this.cfg.dynamicStatic);
        newOption = _.extend(newOption, {
          type: parseInt(this.formRecord.type)
        });
      } else {
        newOption = editItem.options;
      }

      eBase
        .send(
          {
            url: editItem.url,
            params: newOption
          },
          editItem.method
        )
        .then(
          res => {
            const record = {};
            record[editItem.field] = res.data.data;
            self.form && self.form.setFieldsValue(record);
          },
          res => {
            if (
              this.cfg &&
              this.cfg.hasOwnProperty("pageId") &&
              this.cfg.pageId == "DeviceTreeManage"
            ) {
              self.form &&
                self.form.setFieldsValue({
                  factor: ""
                });
              this.$message.info(res.data.msg);
            }
          }
        );
    },

    setFormRecord(record) {
      this.formRecord = record;
    },

    checkMn(record) {
      let result = false;
      if (
        this.cfg &&
        this.cfg.hasOwnProperty("pageId") &&
        this.cfg.pageId == "DeviceTreeManage"
      ) {
        if (
          this.checkOneField(record, "mn") &&
          this.checkOneField(record, "factor")
        ) {
          result = false;
        } else if (
          !this.checkOneField(record, "mn") &&
          this.checkOneField(record, "factor")
        ) {
          result = true;
          this.$message.info("请填写mn");
        } else if (
          !this.checkOneField(record, "factor") &&
          this.checkOneField(record, "mn")
        ) {
          result = true;
          this.$message.info("请填写因子");
        }
      }

      return result;
    },

    checkOneField(record, field) {
      let result = true;

      if (
        _.isUndefined(record[field]) ||
        record[field] === "" ||
        record[field] + "" === "null"
      ) {
        result = false;
      }

      return result;
    },

    getDetailValue(editItem) {
      const item = _.find(editItem.list, one => one.value == editItem.value);
      if (item) {
        return item.label;
      }
      return "";
    },

    getDyamicSelectDetailValue(editItem) {
      const field = editItem.hasOwnProperty("detailField")
        ? editItem.detailField
        : editItem.field;
      const value = this.currentDetailRecord[field];
      if (value) {
        return value;
      }
      return "";
    },

    moreClick() {
      if (
        this.cfg &&
        this.cfg.hasOwnProperty("pageId") &&
        this.cfg.pageId == "EnterpriseManager"
      ) {
        this.collapseMode = !this.collapseMode;
        if (this.collapseMode) {
          this.rowStyle = {
            maxHeight: "400px",
            overflow: "hidden"
          };
        } else {
          this.rowStyle = {
            maxHeight: "2000px",
            overflow: "hidden"
          };
        }
      }
    }
  } // EOF methods
};
</script>



// WEBPACK FOOTER //
// src/components/common/ModelTable.vue